var $=jQuery;
jQuery(document).ready(function ($) {

   $(document).on("click", ".submit_form", function(e) {
      e.preventDefault(); 
      var $form = $(this).closest("form");
      var variantId = $form.find("select[name='id']").val() || $(this).data("pro-id");
      $.ajax({
        type: "POST",
        url: window.Shopify.routes.root + "cart/add.js",
        data: JSON.stringify({
          id: variantId,
          quantity: 1
        }),
        dataType: "json",      
        contentType: "application/json",
        success: function(data) {
          var url = new URL(window.location.href);
          url.searchParams.set("open_cart", "1");
          window.location.href = url.toString();
        },
        error: function(xhr, status, error) {
          console.error("Add to cart error:", error);
        }
      });
    });
  /*** MINI CART  ***/ 

  
  if ($('.newsletter-form__message').length) {
    $('main#MainContent').addClass('active');
  } else {
    $('main#MainContent').removeClass('active');
  }
  $(' .filter-right h6, .step_2_block').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });
  $('.has-dropdown p.footer-block__heading.inline-richtext').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });
  function slider_mobile() {
    if($(window).width() <= 949){
      $('.card-wrapper-produkt_hover_image').click(function (e) { 
        // e.preventDefault();
        $(this).addClass('active');
      });
      var swiper = new Swiper('.custom-anouncement-bar', {
        slidesPerView: 1,
        spaceBetween:0,
        loop: true,
        centeredSlides: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        }
      });
      $(".featured-blog-section .blog__posts.articles-wrapper").flickity({
          pageDots: true,
          freeScroll: false,
          wrapAround: true,
          prevNextButtons: false,
          autoPlay: 7000,
          groupCells: false,
          cellAlign: 'left',
      });
      $(".tastes_best-list").flickity({
          pageDots: false,
          freeScroll: false,
          wrapAround: true,
          prevNextButtons: true,
          autoPlay: 7000,
          groupCells: false,
          cellAlign: 'left',
      });
      $(".nt_haff .multicolumn-list").flickity({
          pageDots: true,
          freeScroll: false,
          wrapAround: true,
          prevNextButtons: false,
          autoPlay: 7000,
          groupCells: false,
          cellAlign: 'left',
            adaptiveHeight: true

            
      });
      $(".nt_staff .multicolumn-list").flickity({
          pageDots: false,
          freeScroll: false,
          wrapAround: true,
          prevNextButtons: true,
          autoPlay: 7000,
          groupCells: false,
          cellAlign: 'left',
      });
       $(".nt_karriere .swiper-wrapper").flickity({
          pageDots: false,
          freeScroll: false,
          wrapAround: true,
          prevNextButtons: true,
          autoPlay: 7000,
          groupCells: false,
          cellAlign: 'left',
      });
    }
  }
  $(document).ready(slider_mobile);
  $(window).on('resize', function() {
    slider_mobile();
  });
  $('.acc-head').on('click', function() {
    if($(this).hasClass('active')) {
      $(this).siblings('.acc-content').slideUp();
      $(this).removeClass('active');
    }
    else {
      $('.acc-content').slideUp();
      $('.acc-head').removeClass('active');
      $(this).siblings('.acc-content').slideToggle();
      $(this).toggleClass('active');
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const scrollBtn = document.getElementById('scroll-to-top');

  window.addEventListener('scroll', () => {
    if (window.scrollY > 2000) {
      scrollBtn.classList.add('show');
    } else {
      scrollBtn.classList.remove('show');
    }
  });

  scrollBtn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
});

document.addEventListener('DOMContentLoaded', function() {
    const loadMoreButton = document.querySelector('.product-grid-container [data-pagination-btn]');
    const productGrid = document.getElementById('product-grid');
    
    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function(e) {
            e.preventDefault();
            const nextUrl = loadMoreButton.getAttribute('href');
            
            loadMoreButton.textContent = "Laden...";
            loadMoreButton.setAttribute('disabled', 'true');
            
            fetch(nextUrl)
                .then(response => response.text())
                .then(data => {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data;
                    
                    const newProducts = tempDiv.querySelector('#product-grid').innerHTML;
                    
                    productGrid.innerHTML += newProducts;
                    // const count = productGrid.querySelectorAll('.grid__item').length;
                    // let countDisplay = document.querySelector('p.products-count span.products-count');
                    // countDisplay.innerHTML = count;
                    // var sliderProducts = document.querySelectorAll('.has-slider-wrapper');

                    // sliderProducts.forEach(function(slider) {
                    //     new Flickity(slider, {
                    //         pageDots: false,
                    //         freeScroll: false,
                    //         wrapAround: true,
                    //         prevNextButtons: true,
                    //         autoPlay: false,
                    //         groupCells: false,
                    //         cellAlign: 'center',
                    //     });
                    // });
                    
                    const newButton = tempDiv.querySelector('.product-grid-container [data-pagination-btn]');
                  
                    if (newButton) {
                        loadMoreButton.setAttribute('href', newButton.getAttribute('href'));
                        loadMoreButton.textContent = "MEHR ARTIKEL ANZEIGEN";
                        loadMoreButton.removeAttribute('disabled');
                    } else {
                        loadMoreButton.textContent = "Keine Produkte mehr";
                        loadMoreButton.style.display = "none";
                    }
                })
                .catch(error => {
                    console.error('Error loading more products:', error);
                    loadMoreButton.textContent = "Try again";
                    loadMoreButton.removeAttribute('disabled');
                });
        });
    }
});

document.addEventListener('DOMContentLoaded', function() {
    const loadMoreButton = document.querySelector('.blog-main-section-custom [data-pagination-btn]');
    const productGrid = document.getElementById('blog-articles');
    
    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function(e) {
            e.preventDefault();
            const nextUrl = loadMoreButton.getAttribute('href');
            
            loadMoreButton.textContent = "Laden...";
            loadMoreButton.setAttribute('disabled', 'true');
            
            fetch(nextUrl)
                .then(response => response.text())
                .then(data => {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data;
                    
                    const newProducts = tempDiv.querySelector('#blog-articles').innerHTML;
                    
                    productGrid.innerHTML += newProducts;
                    // const count = productGrid.querySelectorAll('.grid__item').length;
                    // let countDisplay = document.querySelector('p.products-count span.products-count');
                    // countDisplay.innerHTML = count;
                    // var sliderProducts = document.querySelectorAll('.has-slider-wrapper');

                    // sliderProducts.forEach(function(slider) {
                    //     new Flickity(slider, {
                    //         pageDots: false,
                    //         freeScroll: false,
                    //         wrapAround: true,
                    //         prevNextButtons: true,
                    //         autoPlay: false,
                    //         groupCells: false,
                    //         cellAlign: 'center',
                    //     });
                    // });
                    
                    const newButton = tempDiv.querySelector('.blog-main-section-custom [data-pagination-btn]');
                  
                    if (newButton) {
                        loadMoreButton.setAttribute('href', newButton.getAttribute('href'));
                        loadMoreButton.textContent = "MEHR ARTIKEL ANZEIGEN";
                        loadMoreButton.removeAttribute('disabled');
                    } else {
                        loadMoreButton.textContent = "Keine Produkte mehr";
                        loadMoreButton.style.display = "none";
                    }
                })
                .catch(error => {
                    console.error('Error loading more products:', error);
                    loadMoreButton.textContent = "Try again";
                    loadMoreButton.removeAttribute('disabled');
                });
        });
    }
});



// load varaint 
$(window).on('load', function() {
  // Locate the script tag containing variant data
  const scriptTag = $('script[data-selected-variant]').first();

  if (scriptTag.length) {
    try {
      const jsonData = JSON.parse(scriptTag.text().trim());
      const featuredMediaId = jsonData.featured_media?.id;
      const sectionIdValue = $('input[name="section-id"]').val();
      
      // Ensure we have both IDs before proceeding
      if (featuredMediaId && sectionIdValue) {
        const mediaId = `${sectionIdValue}-${featuredMediaId}`;
        const thumbnail = $(`li[data-att="${mediaId}"]`);

        if (thumbnail.length) {
          console.log('Thumbnail found, waiting for Flickity...');

          // --- FIX: Polling mechanism to wait for Flickity initialization ---
          const checkFlickityInterval = setInterval(() => {
            const $gallery = $('.product-single__gallery');
            const flkty = $gallery.data('flickity');

            // Check if Flickity is fully initialized and has cells
            if (flkty && flkty.cells && flkty.cells.length > 0) {
              clearInterval(checkFlickityInterval); // Stop checking
              console.log('Flickity ready. Triggering click.');
              thumbnail.click(); // Trigger the click safely
            }
          }, 100); // Check every 100ms

          // Safety timeout: Stop checking after 5 seconds to prevent infinite loops
          setTimeout(() => {
            clearInterval(checkFlickityInterval);
          }, 1000);
        }
      }
    } catch (e) {
      console.error('Error parsing variant JSON:', e);
    }
  }
});


// load varaint 
